import { render, staticRenderFns } from "./tableVat.vue?vue&type=template&id=7322a567&scoped=true"
import script from "./tableVat.vue?vue&type=script&lang=js"
export * from "./tableVat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7322a567",
  null
  
)

export default component.exports